export enum ConsistencyRules {
  BestTradeProfitLimit = 'best-trade-profit-limit',
  ProfitableDays = 'profitable-days',
  ProfitableMonths = 'profitable-months',
  MinimumTrades = 'minimum-trades',
  SymbolConsistency = 'symbol-consistency',
}

export interface ConsistencyRuleResult {
  isValid: boolean;
  current: number;
  metadata?: MetadataResult;
}

export interface MetadataResult {
  [key: string]: unknown;
}

export interface ConsistentRulesConfig {
  rule: ConsistencyRules;
  value: number;
  secondaryValue?: number;
}

export type BestTradeProfitLimitConfig = ConsistentRulesConfig;
export type ProfitableDaysConfig = ConsistentRulesConfig;
export type ProfitableDaysResult = { profitableDays: Date[] };
export type ConsistencyRulesValues = ProfitableDaysResult;
